import { sharedLib } from "@shared/services/shared.service";
import { skipToken } from "@reduxjs/toolkit/query";
import { useEffect, useMemo, useState } from "react";
import { JobStatus } from "@shared/types";

export const useJobQuery = (jobId?: string, withFetch?: boolean) => {
  const args = useMemo(() => (jobId ? { job_id: jobId } : undefined), [jobId]);
  const [completedJobId, setCompletedJobId] = useState<string | undefined>();
  sharedLib.sharedApi.common.useGetJobResultsQuery(
    (withFetch ? args : undefined) ?? skipToken,
    { pollingInterval: completedJobId === jobId ? 0 : 3000 }
  );
  const queryStatus =
    sharedLib.sharedApi.common.endpoints.getJobResults.useQueryState(
      args ?? skipToken
    );

  const jobStatus = queryStatus.currentData?.status;
  useEffect(() => {
    if (
      queryStatus.isError ||
      jobStatus === JobStatus.FAILED ||
      jobStatus === JobStatus.FINISHED
    ) {
      setCompletedJobId(queryStatus.originalArgs?.job_id);
    } else if (completedJobId) {
      setCompletedJobId(undefined);
    }
  }, [queryStatus.isError, jobStatus]);

  return {
    ...queryStatus,
    data: queryStatus.currentData,
  };
};
